/* eslint-disable import/prefer-default-export */

/** Types that can no longer be created, but existing guides remain visible in the list. */
export const NON_CREATABLE_GUIDE_TYPES = ['website'];

export const GUIDE_OPTIONS = [
  {
    type: 'text',
    icon: 'text-outline',
    title: 'guides.type_options.text.title',
    description: 'guides.type_options.text.description',
    get route() {
      return `/retailers/${ENV.SLUG}/chatbot_ai/guides/new?type=${this.type}`;
    },
    beta: false
  },
  {
    type: 'document',
    icon: 'new-document',
    title: 'guides.type_options.documents.title',
    description: 'guides.type_options.documents.description',
    get route() {
      return `/retailers/${ENV.SLUG}/chatbot_ai/guides/new?type=${this.type}`;
    },
    beta: true
  },
  {
    type: 'q&a',
    icon: 'question-mark-circle-outline',
    title: 'guides.type_options.questions_and_answers.title',
    description: 'guides.type_options.questions_and_answers.description',
    get route() {
      const encodedType = encodeURIComponent(this.type);
      return `/retailers/${ENV.SLUG}/chatbot_ai/guides/new?type=${encodedType}`;
    },
    beta: false
  }
];

/** Legacy types kept for list display / filters (not offered in create UI). */
export const LEGACY_GUIDE_OPTIONS = [
  {
    type: 'website',
    icon: 'web',
    title: 'guides.type_options.website.title',
    description: 'guides.type_options.website.description',
    get route() {
      return `/retailers/${ENV.SLUG}/chatbot_ai/guides/new?type=${this.type}`;
    },
    beta: false
  }
];

export const ALL_GUIDE_OPTIONS = [...GUIDE_OPTIONS, ...LEGACY_GUIDE_OPTIONS];
